import {ReactNode} from 'react';

type Props = {
  children?: ReactNode;
};

export default function BlockquoteBlock({children}: Props) {
  return <blockquote className="prose-px text-p5">{children}</blockquote>;
}
